import type { OfferPipeline } from "@/types/offer";

/** Engine customContext tags for intake-to-engine traceability. */
export function buildEngineCustomContext(flow: OfferPipeline, intakeId: string): string {
  return `[flow:${flow}][intakeid:${intakeId}]`;
}
